import { render } from "./SearchPage.vue?vue&type=template&id=f144de70&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"

import "./SearchPage.vue?vue&type=style&index=0&id=f144de70&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f144de70"]])

export default __exports__